import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AddCharityComponent } from './add-charity/add-charity.component';

const routes: Routes = [
  {
    path: '',
    component: AddCharityComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CharityRoutingModule {}
